import type { RequiredFieldsConfig } from '../../../domain/types/configs/company/RequiredFieldsConfig';

export const requiredFieldsConfig: RequiredFieldsConfig = {
  fieldsExcluyed: {
    charges: []
  }
}; 